<template>
  <div style="margin-left: 40px;margin-right: 40px;">
    <div class="source">
      <el-row class="querypanel">
        <el-col :span="8">
          <div class="leftpanel">
            <div>产品分类列表:</div>
            <el-tree
              class="filter-tree"
              show-checkbox
              node-key="id"
              ref="gt_tree_list"
              :data="gt_usergroupsdata"
              :props="gt_defaultProps"
              :check-strictly = "true"
              default-expand-all
              :expand-on-click-node="false"
              :render-content="gt_renderugcontext">
            </el-tree>
            <div class="desinfo"> *请先增加总分类，然后依次增加，注意总分类只能有一个，总分类下可以设置三级子分类。</div>
          </div>
        </el-col>
        <el-col :span="16">
          <div class="rightpanel">
            <el-collapse v-model="gt_activeNames" accordion >
              <el-collapse-item title="总分类" name="0">
                <el-form ref="form"  label-width="180px" label-position="left" class="tabcard">
                  <el-form-item label="总分类">
                    <el-input v-model="gt_gsbminfo"></el-input>
                  </el-form-item>
                  <el-form-item label="新增一级分类">
                  <el-input v-model="gt_nameone" placeholder="仅新增一级分类时添加"></el-input>
                </el-form-item>
                  <el-button @click="gt_addzero">新增总分类</el-button>
                  <el-button @click="gt_changezero">修改并保存</el-button>
                  <el-button @click="gt_addone">新增一级子分类</el-button>
                </el-form>
              </el-collapse-item>
              <el-collapse-item title="一级分类" name="1">
                <el-form ref="form"  label-width="180px" label-position="left" class="tabcard">
                  <el-form-item label="当前一级分类">
                    <el-input v-model="gt_gsbmone"></el-input>
                  </el-form-item>
                  <el-form-item label="当前分类次序">
                    <el-input v-model="gt_indexone"></el-input>
                  </el-form-item>
                  <el-form-item label="新增二级分类">
                    <el-input v-model="gt_nametwo" placeholder="仅新增二级分类时添加"></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-button @click="gt_changeone">修改并保存</el-button>
                    <el-button @click="gt_addtwo">新增二级分类</el-button>
                  </el-form-item>
                </el-form>
              </el-collapse-item>
              <el-collapse-item title="二级分类" name="2">
                <el-form ref="form"  label-width="180px" label-position="left" class="tabcard">
                  <el-form-item label="当前二级分类">
                    <el-input v-model="gt_gsbmtwo"></el-input>
                  </el-form-item>
                  <el-form-item label="当前分类次序">
                    <el-input v-model="gt_indextwo"></el-input>
                  </el-form-item>
                  <el-form-item label="新增三级分类">
                    <el-input v-model="gt_namethree" placeholder="仅新增三级分类添加"></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-button @click="gt_changetwo">修改并保存</el-button>
                    <el-button @click="gt_addthree">新增三级分类</el-button>
                  </el-form-item>
                  <div>

                  </div>
                </el-form>
              </el-collapse-item>
              <el-collapse-item title="三级分类" name="3">
                <el-form ref="form"  label-width="180px" label-position="left" class="tabcard">
                  <el-form-item label="当前三级分类">
                    <el-input v-model="gt_gsbmthree"></el-input>
                  </el-form-item>
                  <el-form-item label="当前分类次序">
                    <el-input v-model="gt_indexthree"></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-button @click="gt_changethree">修改并保存</el-button>
                  </el-form-item>
                </el-form>
              </el-collapse-item>
            </el-collapse>
          </div>
        </el-col>
      </el-row>
      <el-row class="querypaneltrans">
        <el-col :span="24">
          <div class="subquerypanel">
            <el-select v-model="typeattr" placeholder="请选择属性类别" @change="selectattrtype" height="120px">
              <el-option
                v-for="item in attrlist"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <span class="desinfoex">  *请点击编辑分类按钮，给分类设定对应的属性，这样在商品选择分类后会直接关联属性</span>
          </div>
        </el-col>
        <el-col :span="15">
          <el-transfer
            filterable
            :titles="['分组属性', '分类属性']"
            filter-placeholder="请输入属性名称"
            v-model="gt_rightdata"
            :data="gt_leftdata"
            :props="{
                key: 'attrid',
                label: 'attrname'
             }"
            @change="handleChange">
          </el-transfer>
        </el-col>
        <el-col :span="1">
          <div class="centerbtn">
            <i class="fa fa fa-angle-double-right  fa-2x curpointer" v-on:click="savetypeattr"></i>
          </div>
        </el-col>
        <el-col :span="8">
          <el-table
            v-loading="loading"
            :data="gt_attrtypetb"
            fit>
            <el-table-column
              type="selection">
            </el-table-column>
            <el-table-column
              prop="attrname.String"
              label="名称"
            >
            </el-table-column>
            <el-table-column
              fixed="right"
              label="操作"
              class-name="outopicondiv"
            >
              <template slot-scope="scope">
                <div class="inopicondiv">
                  <i class="fa fa-trash-o opicon curpointer" v-on:click="removetypeattr(scope.$index, gt_attrtypetb)"> 删除 </i>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import '../../../static/css/my.css'
Vue.prototype.$http = axios
var that
var curpagedata
var curdata
export default {
  name: 'GoodsType',
  beforeCreate: function () {
    that = this
    console.log('开始创建')
  },
  mounted: function () {
    console.log('mounted')
    var v = getCookie('cusid')
    this.khid = v
    that = this
    if (that.khid === null) {
      that.$message({
        type: 'info',
        message: 'Cookie已失效，请重新登录!'
      })
      that.$router.push({path: '/'})
    } else {
      that.$http({
        url: 'https://api.sqnetsoft.cn/goods/gtgt',
        method: 'post',
        data: {
          cusid: parseInt(v),
          parentid: -1
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log(res)
          console.log(JSON.parse(res.data.data))
          if (res.data.success) {
            that.gt_usergroupsdata = JSON.parse(res.data.data)
            that.gt_treereccount = JSON.parse(res.data.data).length
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    }
  },
  data () {
    return {
      gt_usergroupsdata: [],
      gt_showcuslist: true,
      gt_query_cusdata: [],
      gt_query_ug_cusname: '',
      gt_typeid: '',
      khid: '',
      gt_activeNames: [],
      gt_query_ug_cusno: '',
      gt_selectnode: [],
      loading: false,
      gt_gsbminfo: '',
      gt_gsbmone: '',
      gt_gsbmtwo: '',
      gt_gsbmthree: '',
      gt_nameone: '',
      gt_leftdata: [],
      gt_rightdata: [],
      gt_attrtypetb: [],
      typeattr: '',
      gt_nametwo: '',
      gt_namethree: '',
      gt_indexone: '',
      gt_indextwo: '',
      gt_indexthree: '',
      gt_treereccount: 0,
      attrlist: [{
        value: '0',
        label: '基础属性'
      }, {
        value: '1',
        label: '规格属性'
      }, {
        value: '2',
        label: '特殊属性'
      }],
      gt_defaultProps: {
        children: 'Children',
        label: 'name'
      }
    }
  },
  methods: {
    handleSizeChange (val) {
      console.log('每页' + val + '条')
    },
    handleCurrentChange (val) {
      console.log('当前页: ' + val)
      this.curpage = val
      curpagedata.splice(0, this.size)
      for (var i = (that.curpage - 1) * this.size; i < (that.curpage - 1) * this.size + this.size; i++) {
        if (curdata[i] != null) {
          curpagedata.push(curdata[i])
        }
      }
    },
    gt_tusergroupclick (data) {
      console.log(data)
    },
    gt_renderugcontext (h, { node, data, store }) {
      return (
        <span style="flex: 1; display: flex; align-items: center; justify-content: space-between; font-size: 14px; padding-right: 8px;">
          <span>
            <span>{data.name}</span>
          </span>
          <span>
            <i class="fa fa-pencil-square-o gtopicon" on-click={ () => this.gt_edit(node, data)}> </i>
            <i class="fa fa-trash-o gtopicon" on-click={ () => this.gt_remove(node, data)}> </i>
          </span>
        </span>
      )
    },
    gt_querycus: function () {
      console.log(this.gt_query_ug_cusname)
      console.log(this.gt_query_ug_cusno)
      var qstr = 'id > 0'
      if (this.gt_query_ug_cusname !== null && this.gt_query_ug_cusname !== '') {
        qstr = qstr + " and name like '%" + this.gt_query_ug_cusname + "%' "
      }
      if (this.gt_query_ug_cusno !== null && this.gt_query_ug_cusno !== '') {
        qstr = qstr + " and bl_num like '%" + this.gt_query_ug_cusno + "%'"
      }
      that.$http({
        url: 'https://api.sqnetsoft.cn/goods/getcus',
        method: 'post',
        data: {
          whereinfo: {String: qstr, Valid: true},
          limit: {String: 'limit 2', Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log(res)
          console.log(JSON.parse(res.data.data))
          if (res.data.success) {
            that.gt_query_cusdata = JSON.parse(res.data.data)
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    gt_seeusergroup (row) {
      console.log(row.id.String)
      that.$http({
        url: 'https://api.sqnetsoft.cn/goods/gtgt',
        method: 'post',
        data: {
          cusid: parseInt(row.id.String),
          parentid: -1
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log(res)
          console.log(JSON.parse(res.data.data))
          if (res.data.success) {
            that.gt_usergroupsdata = JSON.parse(res.data.data)
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    gt_edit (node, data) {
      console.log(node)
      console.log(data)
      this.gt_selectnode = data
      this.gt_activeNames = [data.level.toString()]
      switch (data.level) {
        case 0: {
          that.gt_gsbminfo = data.name
          break
        }
        case 1: {
          that.gt_gsbmone = data.name
          that.gt_indexone = data.sortindex
          break
        }
        case 2: {
          that.gt_gsbmtwo = data.name
          that.gt_indextwo = data.sortindex
          break
        }
        case 3: {
          that.gt_gsbmthree = data.name
          that.gt_indexthree = data.sortindex
          break
        }
      }
      if (that.gt_typeid === '') {
        that.$message({
          type: 'info',
          message: '请选择属性类别,编辑的情况请忽视提示'
        })
      } else {
        var idstr = 'cusid = ' + that.khid + ' and goods_type_id=' + parseInt(data.id) + ' and attr_type_id=' + parseInt(that.gt_typeid)
        that.$http({
          url: 'https://api.sqnetsoft.cn/goods/qgta',
          method: 'post',
          data: {
            whereinfo: {'String': idstr, Valid: true}
          },
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            console.log(res)
            if (res.data.success) {
              that.loading = false
              console.log(res.data.data)
              that.gt_attrtypetb = JSON.parse(res.data.data)
              that.$message({
                type: 'success',
                message: '已读取分类属性'
              })
            } else {
              that.loading = false
            }
          })
          .catch(function (error) {
            that.loading = false
            console.log('error' + error)
          })
      }
    },
    gt_remove (node, data) {
      console.log(node)
      console.log(data)
      var idlist = []
      if (data.haschild === 0) {
        idlist.push(data.id)
      } else {
        idlist.push(data.id)
        var cnode = data.Children
        for (var index in cnode) {
          console.log(cnode[index])
          idlist.push(cnode[index].id)
          if (cnode[index].haschild === 0) {
          } else {
            var cinode = cnode[index].Children
            for (var i in cinode) {
              idlist.push(cinode[i].id)
              if (cinode[i].haschild === 0) {
              } else {
                var ciinode = cinode[i].Children
                for (var j in ciinode.Children) {
                  idlist.push(ciinode.Children[j].id)
                  if (cinode[i].haschild === 0) {
                  } else {
                    for (var k in ciinode.Children) {
                      idlist.push(ciinode.Children[k].id)
                    }
                  }
                }
              }
            }
          }
        }
      }
      var idstr = 'id in (' + idlist + ')'
      that.$http({
        url: 'https://api.sqnetsoft.cn/goods/dgt',
        method: 'post',
        data: {
          whereinfo: {String: idstr, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            if (res.data.success) {
              that.$http({
                url: 'https://api.sqnetsoft.cn/goods/gtgt',
                method: 'post',
                data: {
                  cusid: parseInt(that.khid),
                  parentid: -1
                },
                headers: {
                  'Content-Type': 'application/json'
                }
              })
                .then(function (res) {
                  that.gt_usergroupsdata = JSON.parse(res.data.data)
                  that.$message({
                    type: 'success',
                    message: '修改成功!'
                  })
                })
                .catch(function (error) {
                  console.log('error' + error)
                })
            }
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    gt_changezero () {
      console.log(this.gt_selectnode)
      that.$http({
        url: 'https://api.sqnetsoft.cn/goods/aaugt',
        method: 'post',
        data: {
          id: {Int64: parseInt(this.gt_selectnode.id), Valid: true},
          cusid: parseInt(this.khid),
          name: {String: this.gt_gsbminfo, Valid: true},
          level: parseInt(this.gt_selectnode.level),
          haschild: parseInt(this.gt_selectnode.haschild),
          parentid: parseInt(-1)
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            that.$http({
              url: 'https://api.sqnetsoft.cn/goods/gtgt',
              method: 'post',
              data: {
                cusid: parseInt(that.khid),
                parentid: -1
              },
              headers: {
                'Content-Type': 'application/json'
              }
            })
              .then(function (res) {
                that.gt_usergroupsdata = JSON.parse(res.data.data)
                if (res.data.success) {
                  that.$message({
                    type: 'success',
                    message: '修改成功!'
                  })
                }
              })
              .catch(function (error) {
                console.log('error' + error)
              })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    gt_addzero () {
      if (that.gt_treereccount <= 0) {
        that.$http({
          url: 'https://api.sqnetsoft.cn/goods/aaugt',
          method: 'post',
          data: {
            cusid: parseInt(that.khid),
            name: {String: that.gt_gsbminfo, Valid: true},
            level: parseInt(0),
            haschild: parseInt(0),
            parentid: parseInt(-1)
          },
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.success) {
              that.$http({
                url: 'https://api.sqnetsoft.cn/goods/gtgt',
                method: 'post',
                data: {
                  cusid: parseInt(that.khid),
                  parentid: -1
                },
                headers: {
                  'Content-Type': 'application/json'
                }
              })
                .then(function (res) {
                  if (res.data.success) {
                    that.$message({
                      type: 'success',
                      message: '添加成功!'
                    })
                  }
                })
                .catch(function (error) {
                  console.log('error' + error)
                })
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      } else {
        that.$message({
          type: 'error',
          message: '只能保留一个总类!'
        })
      }
    },
    gt_changeone () {
      that.$http({
        url: 'https://api.sqnetsoft.cn/goods/aaugt',
        method: 'post',
        data: {
          id: {Int64: parseInt(this.gt_selectnode.id), Valid: true},
          cusid: parseInt(this.khid),
          name: {String: this.gt_gsbmone, Valid: true},
          level: parseInt(this.gt_selectnode.level),
          haschild: parseInt(this.gt_selectnode.haschild),
          parentid: parseInt(this.gt_selectnode.parentid),
          sortindex: parseInt(this.gt_indexone)
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            that.$http({
              url: 'https://api.sqnetsoft.cn/goods/gtgt',
              method: 'post',
              data: {
                cusid: parseInt(that.khid),
                parentid: -1
              },
              headers: {
                'Content-Type': 'application/json'
              }
            })
              .then(function (res) {
                if (res.data.success) {
                  that.gt_usergroupsdata = JSON.parse(res.data.data)
                  that.$message({
                    type: 'success',
                    message: '修改成功!'
                  })
                }
              })
              .catch(function (error) {
                console.log('error' + error)
              })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    gt_changetwo () {
      that.$http({
        url: 'https://api.sqnetsoft.cn/goods/aaugt',
        method: 'post',
        data: {
          id: {Int64: parseInt(this.gt_selectnode.id), Valid: true},
          cusid: parseInt(this.khid),
          name: {String: this.gt_gsbmtwo, Valid: true},
          level: parseInt(this.gt_selectnode.level),
          haschild: parseInt(that.gt_selectnode.haschild),
          parentid: parseInt(that.gt_selectnode.parentid),
          sortindex: parseInt(this.gt_indextwo)
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            that.$http({
              url: 'https://api.sqnetsoft.cn/goods/gtgt',
              method: 'post',
              data: {
                cusid: parseInt(that.khid),
                parentid: -1
              },
              headers: {
                'Content-Type': 'application/json'
              }
            })
              .then(function (res) {
                if (res.data.success) {
                  that.gt_usergroupsdata = JSON.parse(res.data.data)
                  that.$message({
                    type: 'success',
                    message: '修改成功!'
                  })
                }
              })
              .catch(function (error) {
                console.log('error' + error)
              })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    gt_changethree () {
      that.$http({
        url: 'https://api.sqnetsoft.cn/goods/aaugt',
        method: 'post',
        data: {
          id: {Int64: parseInt(that.gt_selectnode.id), Valid: true},
          cusid: parseInt(that.khid),
          name: {String: that.gt_gsbmthree, Valid: true},
          level: parseInt(that.gt_selectnode.level),
          haschild: parseInt(that.gt_selectnode.haschild),
          parentid: parseInt(that.gt_selectnode.parentid),
          sortindex: parseInt(this.gt_indexthree)
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            that.$http({
              url: 'https://api.sqnetsoft.cn/goods/gtgt',
              method: 'post',
              data: {
                cusid: parseInt(that.khid),
                parentid: -1
              },
              headers: {
                'Content-Type': 'application/json'
              }
            })
              .then(function (res) {
                if (res.data.success) {
                  that.gt_usergroupsdata = JSON.parse(res.data.data)
                  that.$message({
                    type: 'success',
                    message: '修改成功!'
                  })
                }
              })
              .catch(function (error) {
                console.log('error' + error)
              })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    gt_addone () {
      console.log(this.gt_selectnode)
      var newnode = []
      var oldobj = {
        id: {Int64: parseInt(this.gt_selectnode.id), Valid: true},
        cusid: parseInt(this.khid),
        name: {String: this.gt_gsbminfo, Valid: true},
        level: parseInt(this.gt_selectnode.level),
        haschild: parseInt(1),
        parentid: parseInt(this.gt_selectnode.parentid),
        sortindex: parseInt(1)
      }
      var newobj = {
        cusid: parseInt(this.khid),
        name: {String: this.gt_nameone, Valid: true},
        level: parseInt(this.gt_selectnode.level) + 1,
        haschild: parseInt(0),
        parentid: parseInt(this.gt_selectnode.id),
        sortindex: parseInt(1)
      }
      newnode.push(oldobj)
      newnode.push(newobj)
      that.$http({
        url: 'https://api.sqnetsoft.cn/goods/paaugt',
        method: 'post',
        data: newnode,
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            that.$http({
              url: 'https://api.sqnetsoft.cn/goods/gtgt',
              method: 'post',
              data: {
                cusid: parseInt(that.khid),
                parentid: -1
              },
              headers: {
                'Content-Type': 'application/json'
              }
            })
              .then(function (res) {
                that.gt_usergroupsdata = JSON.parse(res.data.data)
                that.$message({
                  type: 'success',
                  message: '修改成功!'
                })
              })
              .catch(function (error) {
                console.log('error' + error)
              })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    gt_addtwo () {
      console.log(this.gt_selectnode)
      var newnode = []
      var oldobj = {
        id: {Int64: parseInt(this.gt_selectnode.id), Valid: true},
        cusid: parseInt(this.khid),
        name: {String: this.gt_gsbmone, Valid: true},
        level: parseInt(this.gt_selectnode.level),
        haschild: parseInt(1),
        parentid: parseInt(this.gt_selectnode.parentid),
        sortindex: parseInt(1)
      }
      var newobj = {
        cusid: parseInt(this.khid),
        name: {String: this.gt_nametwo, Valid: true},
        level: parseInt(this.gt_selectnode.level) + 1,
        haschild: parseInt(0),
        parentid: parseInt(this.gt_selectnode.id),
        sortindex: parseInt(1)
      }
      newnode.push(oldobj)
      newnode.push(newobj)
      console.log(newnode)
      that.$http({
        url: 'https://api.sqnetsoft.cn/goods/paaugt',
        method: 'post',
        data: newnode,
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            that.$http({
              url: 'https://api.sqnetsoft.cn/goods/gtgt',
              method: 'post',
              data: {
                cusid: parseInt(that.khid),
                parentid: -1
              },
              headers: {
                'Content-Type': 'application/json'
              }
            })
              .then(function (res) {
                that.gt_usergroupsdata = JSON.parse(res.data.data)
                that.$message({
                  type: 'success',
                  message: '修改成功!'
                })
              })
              .catch(function (error) {
                console.log('error' + error)
              })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    gt_addthree () {
      console.log(this.gt_selectnode)
      var newnode = []
      var oldobj = {
        id: {Int64: parseInt(this.gt_selectnode.id), Valid: true},
        cusid: parseInt(this.khid),
        name: {String: this.gt_gsbmtwo, Valid: true},
        level: parseInt(this.gt_selectnode.level),
        haschild: parseInt(1),
        parentid: parseInt(this.gt_selectnode.parentid),
        sortindex: parseInt(1)
      }
      var newobj = {
        cusid: parseInt(this.khid),
        name: {String: this.gt_namethree, Valid: true},
        level: parseInt(this.gt_selectnode.level) + 1,
        haschild: parseInt(0),
        parentid: parseInt(this.gt_selectnode.id),
        sortindex: parseInt(1)
      }
      newnode.push(oldobj)
      newnode.push(newobj)
      console.log(newnode)
      that.$http({
        url: 'https://api.sqnetsoft.cn/goods/paaugt',
        method: 'post',
        data: newnode,
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            that.$http({
              url: 'https://api.sqnetsoft.cn/goods/gtgt',
              method: 'post',
              data: {
                cusid: parseInt(that.khid),
                parentid: -1
              },
              headers: {
                'Content-Type': 'application/json'
              }
            })
              .then(function (res) {
                that.gt_usergroupsdata = JSON.parse(res.data.data)
                that.$message({
                  type: 'success',
                  message: '修改成功!'
                })
              })
              .catch(function (error) {
                console.log('error' + error)
              })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    savetypeattr () {
      that.loading = true
      console.log('获取分类列表')
      console.log(this.gt_rightdata)
      console.log(this.gt_leftdata)
      if (this.gt_rightdata.length === 0) {
        that.$message({
          type: 'info',
          message: '信息不完整'
        })
      } else {
        var attlist = []
        var gtlisttmp = this.$refs.gt_tree_list.getCheckedKeys()
        console.log(this.$refs.gt_tree_list)
        console.log(gtlisttmp)
        for (var gtindex in gtlisttmp) {
          var gtinfotmp = gtlisttmp[gtindex]
          console.log(gtinfotmp)
          for (var index in this.gt_rightdata) {
            var subdata = this.gt_rightdata[index]
            console.log('subdata')
            console.log(subdata)
            var dataindex = this.gt_leftdata.findIndex(d => d.attrid === subdata)
            var subdataname = this.gt_leftdata[dataindex]
            console.log(subdataname)
            var adata
            adata = {
              goodstypeid: parseInt(gtinfotmp),
              attrtypeid: parseInt(that.gt_typeid),
              attrid: parseInt(subdata),
              attrname: {'String': subdataname.attrname, Valid: true},
              cusid: parseInt(this.khid)
            }
            attlist.push(adata)
          }
        }
        console.log(attlist)
        that.loading = true
        that.$http({
          url: 'https://api.sqnetsoft.cn/goods/paaugta',
          method: 'post',
          data: attlist,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            console.log(res)
            if (res.data.success) {
              var idstr = 'cusid = ' + that.khid + ' and goods_type_id in (' + gtlisttmp + ')'
              that.$http({
                url: 'https://api.sqnetsoft.cn/goods/qgta',
                method: 'post',
                data: {
                  whereinfo: {'String': idstr, Valid: true}
                },
                headers: {
                  'Content-Type': 'application/json'
                }
              })
                .then(function (res) {
                  console.log(res)
                  if (res.data.success) {
                    that.loading = false
                    console.log(res.data.data)
                    that.gt_attrtypetb = JSON.parse(res.data.data)
                    that.$message({
                      type: 'success',
                      message: '已保存至分类'
                    })
                    that.gt_rightdata = []
                  } else {
                    that.loading = false
                  }
                })
                .catch(function (error) {
                  that.loading = false
                  console.log('error' + error)
                })
            } else {
              that.loading = false
            }
          })
          .catch(function (error) {
            that.loading = false
            console.log('error' + error)
          })
      }
    },
    handleChange () {
    },
    selectattrtype (value) {
      that.gt_typeid = value
      var idstr = 'cusid = ' + that.khid + ' and attr_type_id=' + value
      that.$http({
        url: 'https://api.sqnetsoft.cn/goods/qgagex',
        method: 'post',
        data: {
          whereinfo: {'String': idstr, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log(res)
          if (res.data.success) {
            that.loading = false
            that.gt_leftdata = JSON.parse(res.data.data)
            console.log('左侧数据')
            console.log(that.gt_leftdata)
            that.$message({
              type: 'success',
              message: '读取完毕'
            })
          } else {
            that.loading = false
          }
        })
        .catch(function (error) {
          that.loading = false
          console.log('error' + error)
        })
      if (that.gt_selectnode.length === 0) {
        that.$message({
          type: 'info',
          message: '分类编辑未选定，无法读取类别属性'
        })
      } else {
        var idstrtmp = 'cusid = ' + that.khid + ' and goods_type_id=' + parseInt(that.gt_selectnode.id) + ' and attr_type_id=' + parseInt(value)
        that.$http({
          url: 'https://api.sqnetsoft.cn/goods/qgta',
          method: 'post',
          data: {
            whereinfo: {'String': idstrtmp, Valid: true}
          },
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            console.log(res)
            if (res.data.success) {
              that.loading = false
              console.log(res.data.data)
              that.gt_attrtypetb = JSON.parse(res.data.data)
              that.$message({
                type: 'success',
                message: '已读取分类属性'
              })
            } else {
              that.loading = false
            }
          })
          .catch(function (error) {
            that.loading = false
            console.log('error' + error)
          })
      }
    },
    removetypeattr (index, data) {
      console.log(data)
      console.log(index)
      var curselectdata = data[index]
      var dataindex = data.findIndex(d => d.id.Int64 === curselectdata.id.Int64)
      // 移除该条数据
      data.splice(dataindex, 1)
      console.log(curselectdata)
      that.$http({
        url: 'https://api.sqnetsoft.cn/goods/dgta',
        method: 'post',
        data: {
          whereinfo: {'String': 'id=' + curselectdata.id.Int64, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log(res)
          if (res.data.success) {
            that.$message({
              type: 'success',
              message: '删除成功!'
            })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    }
  }
}
function getCookie (name) {
  var v = window.document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)')
  return v ? v[2] : null
}
</script>



// WEBPACK FOOTER //
// src/components/goods/GoodsType.vue